import { useEffect } from 'react'

export const ClearDeviceFaultsResult = ({ setShowCommandModal }) => {
  useEffect(() => setShowCommandModal(false), [setShowCommandModal])
  return null
}
